import { ReviewDiffCellDetail } from "../../services/if-definitions";
import { buildDiffSegments, normalizeDiffValue } from "../../util/diff-util";
import { DiffText } from "./DiffText";

export type DiffTooltipDetail = ReviewDiffCellDetail & {
  tooltipLabel?: string;
};

type Props = {
  diff?: DiffTooltipDetail;
  x: number;
  y: number;
  visible: boolean;
  maxWidth?: number;
  maxHeight?: number;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onMouseDown?: () => void;
};

export const DiffTooltip = ({
  diff,
  x,
  y,
  visible,
  maxWidth = 320,
  maxHeight = 220,
  onMouseEnter,
  onMouseLeave,
  onMouseDown,
}: Props) => {
  if (!visible || !diff) return null;

  const segments = buildDiffSegments(
    normalizeDiffValue(diff.before),
    normalizeDiffValue(diff.after),
  );

  return (
    <div
      data-diff-tooltip="true"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onMouseDown={(e) => {
        e.stopPropagation();
        onMouseDown?.();
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
      onWheel={(e) => {
        e.stopPropagation();
      }}
      style={{
        position: "fixed",
        top: `${y}px`,
        left: `${x}px`,
        zIndex: 9999,
        padding: "8px 12px",
        background: "#333",
        color: "#fff",
        borderRadius: "4px",
        pointerEvents: "auto",
        userSelect: "text",
        cursor: "text",
        fontSize: "12px",
        lineHeight: 1.5,
        whiteSpace: "pre-wrap",
        overflowWrap: "anywhere",
        wordBreak: "break-word",
        boxSizing: "border-box",
        maxWidth: `${maxWidth}px`,
        maxHeight: `${maxHeight}px`,
        overflowY: "auto",
        overscrollBehavior: "contain",
      }}
    >
      {diff.tooltipLabel ? (
        <div style={{ fontWeight: 700 }}>{diff.tooltipLabel}</div>
      ) : (
        <>
          <div style={{ fontWeight: 700, marginBottom: "4px" }}>[Before]</div>
          <div>
            <DiffText segments={segments.before} kind="before" />
          </div>

          <div style={{ fontWeight: 700, margin: "8px 0 4px" }}>[After]</div>
          <div>
            <DiffText segments={segments.after} kind="after" />
          </div>
        </>
      )}
    </div>
  );
};
